export enum connectNavTestIds {
  LOGO = "nav-logo",
  INVITES = "nav-invites",
  APPLICATIONS = "nav-applications",
  JOBS = "nav-jobs",
  QUIZ = "nav-quiz",
  PROFILE = "nav-profile",
}

export const enum componentDialogTestIds {
  CLOSE_BUTTON_ELEMENT = "dialog-close-button-element",
}

export const enum componentLoaderTestIds {
  ELEMENT = "loader-element",
}

export const enum componentMultiSelectTestIds {
  CHECK_ELEMENT = "multi-select-check-element",
}

export const enum componentMilesSliderTestIds {
  SLIDER_TRIGGER_ELEMENT = "miles-slider-trigger",
  SLIDER_VALUE_ELEMENT = "miles-slider-value",
}

export enum responseErrorAlertTestIds {
  CONTAINER_ELEMENT = "response-error-alert-container-element",
}

export enum authTestIds {
  EMAIL_INPUT = "auth-email-input",
  SUBMIT_BUTTON = "auth-submit-button",
  GOOGLE_BUTTON = "google-sign-in-button",
  CONTINUE_WITH_GOOGLE_BUTTON = "auth-continue-with-google-button",
  CONTINUE_WITH_EMAIL_BUTTON = "auth-continue-with-email-button",
  BACK_TO_METHODS_BUTTON = "auth-back-to-methods-button",
  GOOGLE_STEP_ERROR = "auth-google-step-error",
  INSTITUTIONAL_EMAIL_WARNING = "auth-institutional-email-warning",
  TERMS_LINK = "auth-terms",
  PRIVACY_POLICY_LINK = "auth-privacy-policy",
  SIGN_IN_BUTTON = "auth-sign-in-button",
  SIGN_UP_BUTTON = "auth-sign-up-button",
  MODAL_SIGN_IN_LINK = "auth-sign-in-link",
  MODAL_SIGN_UP_LINK = "auth-sign-up-link",
  OTP_INPUT = "auth-otp-input",
  OTP_VERIFY_BUTTON = "auth-otp-verify-button",
  OTP_RESEND_BUTTON = "auth-otp-resend-button",
  OTP_BACK_BUTTON = "auth-otp-back-button",
  SIGN_IN_INVITES_TAB = "auth-sign-in-invites-tab",
  SIGN_IN_APPLICATIONS_TAB = "auth-sign-in-applications-tab",
  SIGN_IN_RECOMMENDED_TAB = "auth-sign-in-recommended-tab",
  SIGN_IN_QUIZ_TAB = "auth-sign-in-quiz-tab",
  SIGN_IN_STATE_SELECTOR = "auth-sign-in-state-selector",
  LAST_USED_INDICATOR = "auth-last-used-indicator",
  AUDIENCE_TOGGLE = "auth-audience-toggle",
  AUDIENCE_TOGGLE_JOB_SEEKERS = "auth-audience-toggle-job-seekers",
  AUDIENCE_TOGGLE_DISTRICT_STAFF = "auth-audience-toggle-district-staff",
  HIRING_PANEL_TRIGGER = "auth-hiring-panel-trigger",
  HIRING_PANEL_CONTENT = "auth-hiring-panel-content",
  NEW_TO_NIMBLE_PANEL_TRIGGER = "auth-new-to-nimble-panel-trigger",
  NEW_TO_NIMBLE_PANEL_CONTENT = "auth-new-to-nimble-panel-content",
  PASSWORD_SIGN_IN_LINK = "auth-password-sign-in-link",
  AUDIENCE_PICKER_JOB_SEEKER_CARD = "auth-audience-picker-job-seeker-card",
  AUDIENCE_PICKER_DISTRICT_STAFF_CARD = "auth-audience-picker-district-staff-card",
  AUDIENCE_PICKER_DISTRICTS_LINK = "auth-audience-picker-districts-link",
  SHARED_DEVICE_CHECKBOX = "auth-shared-device",
}

export enum discoverSavedTabNavigationTestIds {
  NAVIGATION = "discover-saved-tab-navigation",
  DISCOVER_TAB = "discover-jobs-tab",
  SAVED_TAB = "saved-jobs-tab",
  SAVED_COUNT = "saved-jobs-tab-count",
}

export interface TabTestIds {
  NAVIGATION: string;
}

export enum recommendedSchoolCardTestIds {
  CARD = "recommended-card",
  CARD_UNAVAILABLE = "recommended-card-unavailable",
  FIT_LABEL = "recommended-fit-label",
  GROUP_HEADER = "recommended-group-header",
}

export enum recommendedPreferencesSidebarTestIds {
  EDIT_BUTTON = "recommended-preferences-edit-button",
  GRADES_SECTION = "recommended-preferences-grades-section",
  HEADER = "recommended-preferences-header",
  INFO_TEXT = "recommended-preferences-info-text",
  LOCATION_SECTION = "recommended-preferences-location-section",
  SIDEBAR = "recommended-preferences-sidebar",
  SUBJECT_SECTION = "recommended-preferences-subjects-section",
}

export enum applicationFormDataTestIds {
  APPLICATION_FORM_STEPPER = "application-form-stepper",
  FIRST_NAME_INPUT = "application-form-first-name",
  MIDDLE_NAME_INPUT = "application-form-middle-name",
  LAST_NAME_INPUT = "application-form-last-name",
  PHONE_INPUT = "application-form-phone",
  STREET_INPUT = "application-form-street",
  STREET_SUGGESTION = "application-form-street-suggestion",
  ADDRESS_SUMMARY = "application-form-address-summary",
  ADDRESS_COMPLETE = "application-form-address-complete",
  ADDRESS_EDIT_DETAILS = "application-form-address-edit-details",
  APT_INPUT = "application-form-apt",
  CITY_INPUT = "application-form-city",
  STATE_INPUT = "application-form-state",
  POSTAL_CODE_INPUT = "application-form-postal-code",
  COUNTRY_INPUT = "application-form-country",
  GENDER_SELECT = "application-form-gender",
  BIRTHDATE = "application-form-birthdate",
  SSN_INPUT = "application-form-ssn",
  SSN_VISIBILITY_TOGGLE = "application-form-ssn-visibility",
  RESUME_UPLOAD = "application-form-resume-upload",
  RESUME_UPDATE = "application-form-resume-update",
  RESUME_ERROR = "application-form-resume-error",
  RESUME_LOADING = "application-form-resume-loading",
  RESUME_SKIP = "application-form-resume-skip",
  RESUME_ATTACHMENT = "application-form-resume-attachment",
  RESUME_ATTACHMENT_UPDATE = "application-form-resume-attachment-update",
  RACE_ETHNICITY_SELECT = "application-form-race-ethnicity",
  EXPERIENCE_ADD = "application-form-experience-add",
  EXPERIENCE_DELETE = "application-form-experience-delete",
  EXPERIENCE_EMPLOYER = "application-form-experience-employer",
  EXPERIENCE_TITLE = "application-form-experience-title",
  EXPERIENCE_DESCRIPTION = "application-form-experience-description",
  EXPERIENCE_START_DATE = "application-form-experience-start-date",
  EXPERIENCE_END_DATE = "application-form-experience-end-date",
  EXPERIENCE_CURRENT = "application-form-experience-current",
  EDUCATION_START_DATE = "application-form-education-start-date",
  EDUCATION_END_DATE = "application-form-education-end-date",
  EDUCATION_CURRENT = "application-form-education-current",
  REVIEW_EDIT_BASIC_INFO = "application-form-review-edit-basic-info",
  REVIEW_EDIT_EXPERIENCE = "application-form-review-edit-experience",
  REVIEW_EDIT_QUESTIONS = "application-form-review-edit-questions",
  EDUCATION_ADD = "application-form-education-add",
  CREDENTIAL_ADD = "application-form-credential-add",
  CREDENTIAL_GRADE = "application-form-credential-grade",
  CREDENTIAL_STATUS = "application-form-credential-status",
  CREDENTIAL_ISSUE_DATE = "application-form-credential-issue-date",
  CREDENTIAL_EXPIRATION_DATE = "application-form-credential-expiration-date",
  LANGUAGE_ADD = "application-form-language-add",
  LANGUAGE_DELETE = "application-form-language-delete",
  LANGUAGE_SELECT = "application-form-language-select",
  LANGUAGE_PROFICIENCY = "application-form-language-proficiency",
  CERTIFICATES_SELECT = "application-form-certificates-select",
  CERTIFICATE_OTHER_NAME = "application-form-certificate-other-name",
  EXAM_ADD = "application-form-exam-add",
  EXAM_DELETE = "application-form-exam-delete",
  EXAM_TYPE = "application-form-exam-type",
  EXAM_SUBJECT = "application-form-exam-subject",
  EXAM_CUSTOM_NAME = "application-form-exam-custom-name",
  EXAM_SCORE = "application-form-exam-score",
  EXAM_MAX_SCORE = "application-form-exam-max-score",
  REFERENCE_ADD = "application-form-reference-add",
  REFERENCE_DELETE = "application-form-reference-delete",
  REFERENCE_FIRST_NAME = "application-form-reference-first-name",
  REFERENCE_LAST_NAME = "application-form-reference-last-name",
  REFERENCE_TITLE = "application-form-reference-title",
  REFERENCE_ORGANIZATION = "application-form-reference-organization",
  REFERENCE_EMAIL = "application-form-reference-email",
  REFERENCE_PHONE = "application-form-reference-phone",
  QUESTION_ANSWER = "application-form-question-answer",
}

export const enum dormantSeasonTestIds {
  PANEL = "dormant-season-panel",
  PANEL_TITLE = "dormant-season-panel-title",
  PANEL_DESCRIPTION = "dormant-season-panel-description",
  BANNER = "dormant-season-banner",
  BANNER_TITLE = "dormant-season-banner-title",
  BANNER_DESCRIPTION = "dormant-season-banner-description",
  CONNECTION_SEASON_CHIP = "dormant-season-connection-chip",
  CONNECTIONS_SEASON_CAPTION = "dormant-season-connections-caption",
  MATCH_STATUS_NOTICE = "dormant-season-match-status-notice",
  MATCH_STATUS_TRACKER_NOTICE = "dormant-season-match-status-tracker-notice",
}
